import script from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ElementPositionPanel.vue?vue&type=style&index=0&id=a2bcea28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2bcea28"]])

export default __exports__